// extracted by mini-css-extract-plugin
module.exports = {"content":"ShopInfo_content__2OfGr","avatar":"ShopInfo_avatar__PP_7_","image":"ShopInfo_image__1z5n7","rotate":"ShopInfo_rotate__DODZ9"};